import { render, staticRenderFns } from "./LimitHistory.vue?vue&type=template&id=ac152d10&"
import script from "./LimitHistory.vue?vue&type=script&lang=js&"
export * from "./LimitHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports